// removed by extract-text-webpack-plugin
module.exports = {"techIcon":"techIcon__W3aqr"};


//////////////////
// WEBPACK FOOTER
// ./components/Icons/style.css
// module id = 50l5
// module chunks = 2